import { Injectable } from '@angular/core';
import { AppStatisticalReportsCompare } from 'src/app/core/types/app-statistical-reports-compare.type';

@Injectable({
  providedIn: 'root',
})
export class StatisticalReportsCompareService {
  static getDailyItemsApiMethodName: string = '';
  static getMonthlyItemsApiMethodName: string = '';
  static statisticalReportsCompareType: AppStatisticalReportsCompare = 'user';
}
